module.exports = __webpack_public_path__ + "static/media/refis-2025.d0e04d25.webp";